import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import InventoryIcon from "@mui/icons-material/Inventory";
import PlayCircleSharpIcon from "@mui/icons-material/PlayCircleSharp";
import ListItemIcon from "@mui/material/ListItemIcon";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import RunCircleSharpIcon from "@mui/icons-material/RunCircleSharp";
import CategorySharpIcon from "@mui/icons-material/CategorySharp";
import SegmentIcon from "@mui/icons-material/Segment";
import { Box, ListSubheader, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import logo from "../static/PPlay_logo.png";
import { Link } from "react-router-dom";
import PaymentsIcon from "@mui/icons-material/Payments";
import "../style/App.css";
import SideBarContext from "../context/SideBarContext";
import ChangeCircleSharpIcon from "@mui/icons-material/ChangeCircleSharp";
import HistoryIcon from "@mui/icons-material/History";
import SlowMotionVideoSharpIcon from "@mui/icons-material/SlowMotionVideoSharp";
import AccessAlarmSharpIcon from "@mui/icons-material/AccessAlarmSharp";
import SportsKabaddiSharpIcon from "@mui/icons-material/SportsKabaddiSharp";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import PeopleIcon from "@mui/icons-material/People";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { PAGE_BG } from "../components/layout/constants";

const drawerWidth = 290;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

const NAV_GROUPS = [
  {
    items: [
      {
        key: "overview",
        matchKeys: ["overview"],
        path: "/overview",
        label: "Overview",
        icon: DashboardIcon,
      },
      {
        key: "user",
        matchKeys: ["user"],
        path: "/user",
        label: "Users",
        icon: AccountCircleSharpIcon,
      },
    ],
  },
  {
    title: "Content",
    items: [
      { key: "video", path: "/video", label: "Video List", icon: PlayCircleSharpIcon },
      { key: "plan", path: "/plan", label: "Plans", icon: RunCircleSharpIcon },
      {
        key: "nuroutine",
        path: "/nuroutine",
        label: "Nutrition Routine",
        icon: ChangeCircleSharpIcon,
      },
      {
        key: "muscleType",
        path: "/muscleType",
        label: "Muscle Type",
        icon: CategorySharpIcon,
      },
      { key: "blog", path: "/blog", label: "Articles", icon: SegmentIcon },
      { key: "ads", path: "/ads", label: "Ads", icon: BrokenImageIcon },
    ],
  },
  {
    title: "Subscriptions",
    items: [
      {
        key: "sub_package",
        path: "/sub_package",
        label: "Subscription Package",
        icon: InventoryIcon,
      },
      {
        key: "banking_acc",
        path: "/banking_acc",
        label: "Manual Payment",
        icon: MonetizationOnIcon,
      },
    ],
  },
  {
    title: "Transactions",
    items: [
      {
        key: "subHistory",
        path: "/subHistory",
        label: "Subscription History",
        icon: SubscriptionsIcon,
      },
      {
        key: "specialHistory",
        path: "/specialHistory",
        label: "Special Package Purchase History",
        icon: HistoryIcon,
      },
      {
        key: "transaction",
        path: "/transaction",
        label: "Payment Transaction",
        icon: PaymentsIcon,
      },
      {
        key: "affiliate_users",
        path: "/affiliate_users",
        label: "Affiliate Users",
        icon: PeopleIcon,
      },
    ],
  },
  {
    title: "Trainers",
    items: [
      {
        key: "special_trainer",
        path: "/special_trainer",
        label: "Special Trainer",
        icon: SportsKabaddiSharpIcon,
      },
      {
        key: "special_package",
        path: "/special_package",
        label: "Special Package",
        icon: AccessAlarmSharpIcon,
      },
      {
        key: "special_video",
        path: "/special_video",
        label: "Special Video",
        icon: SlowMotionVideoSharpIcon,
      },
      {
        key: "live_video",
        path: "/live_video",
        label: "Live Videos",
        icon: LiveTvIcon,
      },
    ],
  },
  {
    title: "System",
    items: [
      {
        key: "push_notification",
        path: "/push-notification",
        label: "Push Notifications",
        icon: NotificationsActiveIcon,
      },
      { key: "settings", path: "/settings", label: "Settings", icon: SettingsIcon },
    ],
  },
];

const isItemActive = (item, nav) => {
  const keys = item.matchKeys || [item.key];
  return keys.includes(nav);
};

const NavItem = ({ item, nav, setNav }) => {
  const Icon = item.icon;
  const active = isItemActive(item, nav);

  return (
    <Link
      to={item.path}
      onClick={() => setNav(item.key)}
      className="nav-link"
    >
      <ListItem button dense className={`nav-btn ${active ? "active" : ""}`}>
        <ListItemIcon className="nav-item-icon">
          <span className="nav-link-icon-wrap">
            <Icon sx={{ fontSize: "18px" }} className="nav-link-icon" />
          </span>
        </ListItemIcon>
        <Typography component="span" className="nav-item-label">
          {item.label}
        </Typography>
      </ListItem>
    </Link>
  );
};

const SideBar = ({ open, handleDrawerClose }) => {
  const { nav, setNav } = useContext(SideBarContext);

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: PAGE_BG,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderBottomRightRadius: 0,
        },
      }}
      className="sidebar"
      variant="persistent"
      anchor="left"
      open={open}
    >
      <Box className="sidebar-inner">
        <DrawerHeader>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              paddingLeft: "0.65rem",
            }}
          >
            <img src={logo} alt="power play" height="24px" />
          </Box>
        </DrawerHeader>

        <Box className="sidebar-nav-scroll">
          <List className="nav-list" sx={{ padding: "0.5rem 0.65rem 0.75rem" }}>
            {NAV_GROUPS.map((group, groupIndex) => (
              <Box key={group.title || `group-${groupIndex}`} className="sidebar-group">
                {group.title && (
                  <ListSubheader
                    className="sidebar-group-title"
                    disableSticky
                    disableGutters
                  >
                    {group.title}
                  </ListSubheader>
                )}
                {group.items.map((item) => (
                  <NavItem
                    key={item.key}
                    item={item}
                    nav={nav}
                    setNav={setNav}
                  />
                ))}
              </Box>
            ))}
          </List>
        </Box>

        <Box
          className="sidebar-collapse-footer"
          onClick={handleDrawerClose}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleDrawerClose();
            }
          }}
        >
          <ChevronLeftIcon fontSize="small" className="sidebar-collapse-icon" />
          <Typography component="span" className="sidebar-collapse-label">
            Collapse
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SideBar;
